import dayTheme from './day';

const colors = {
  ...dayTheme.colors,
  slate: {
    1: '#151718',
    2: '#1a1d1e',
    3: '#202425',
    4: '#26292b',
    5: '#2b2f31',
    6: '#313538',
    7: '#3a3f42',
    8: '#4c5155',
    9: '#697177',
    10: '#787f85',
    11: '#9ba1a6',
    12: '#ecedee',
  },
  indigo: {
    1: '#131620',
    2: '#15192d',
    3: '#192140',
    4: '#1c274f',
    5: '#1f2c5c',
    6: '#22346e',
    7: '#273e89',
    8: '#2f4eb2',
    9: '#3e63dd',
    10: '#5373e7',
    11: '#849dff',
    12: '#eef1fd',
  },
  red: {
    1: '#1f1315',
    2: '#291415',
    3: '#3c181a',
    4: '#481a1d',
    5: '#541b1f',
    6: '#671e22',
    7: '#822025',
    9: '#e5484d',
    10: '#f2555a',
    11: '#ff6369',
    12: '#feecee',
  },
  green: {
    1: '#0d1912',
    2: '#0c1f17',
    3: '#0f291e',
    4: '#113123',
    5: '#133929',
    6: '#164430',
    7: '#1b543a',
    8: '#236e4a',
    9: '#30a46c',
    10: '#3cb179',
    11: '#4cc38a',
    12: '#e5fbeb',
  },
};

const alias = {
  bg: colors.slate[2],
  fg: colors.white,
  light: colors.slate[4],
  layer: colors.overlay[11],
  shadow: colors.slate[6],
  subtle: colors.slate[11],
  danger: colors.red[9],
  dangerBack: colors.red[2],
  dangerNext: colors.red[10],
  primary: colors.indigo[9],
  primaryBack: colors.indigo[2],
  primaryNext: colors.indigo[10],
  success: colors.green[9],
  successBack: colors.green[2],
  successNext: colors.green[10],
  focusBg: colors.indigo[4],
};

const shadows = {
  all: `${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} 1px ${alias.shadow}`,
  top: `${dayTheme.space[0]} -1px ${dayTheme.space[0]} ${dayTheme.space[0]} ${alias.shadow}`,
  left: `-1px ${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} ${alias.shadow}`,
  right: `1px ${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} ${alias.shadow}`,
  bottom: `${dayTheme.space[0]} 1px ${dayTheme.space[0]} ${dayTheme.space[0]} ${alias.shadow}`,
  x: `-1px ${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} ${alias.shadow}, 1px ${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} ${alias.shadow}`,
  y: `${dayTheme.space[0]} -1px ${dayTheme.space[0]} ${dayTheme.space[0]} ${alias.shadow}, ${dayTheme.space[0]} 1px ${dayTheme.space[0]} ${dayTheme.space[0]} ${alias.shadow}`,
  focusAlt: `${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} 1px ${alias.bg}, ${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} 2px ${alias.primary}`,
  focusOuter: `${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} 1px ${alias.primary}`,
  focusInner: `inset ${dayTheme.space[0]} ${dayTheme.space[0]} ${dayTheme.space[0]} 1px ${alias.primary}`,
};

const nightTheme = {
  ...dayTheme,
  colors,
  alias,
  shadows,
};

export default nightTheme;
